module.exports = __webpack_public_path__ + "static/media/Userpic.25b9e312.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Userpic.jpg
// module id = 111
// module chunks = 0